import FormTitle from '@core/components/FormTitle';
import { TextLabel } from '@core/components/Inputs';
import { DataBR } from '@format';
import { Grid, IconButton, Tooltip } from '@material-ui/core';
import { confirmarAlert } from 'app/services/alerts';
import { getCurrency } from 'app/utils/monetarioUtil';
import React, { useState } from 'react';
import { MdHighlightOff } from 'react-icons/md';

const FORMA_RECEBIMENTO = {
  BOLETO: 'Boleto',
  PIX: 'Pix',
  CARTAO_DEBITO: 'Cartão de débito',
  CARTAO_CREDITO: 'Cartão de crédito',
  DINHEIRO: 'Dinheiro',
  TED_DOC: 'TED/DOC',
  CHEQUE: 'Cheque',
  OUTRAS: 'Outras',
};

const ContaReceberRecebimentosRealizados = ({ showCancelarBaixa = true, showTitle = true, baixas, formik }) => {
  const [baixasState, setBaixasState] = useState(baixas);
  const [, setCancelarBaixas] = useState([]);

  const handleCancelarBaixa = (id) => () => {
    confirmarAlert({
      opcoes: {
        title: 'Tem certeza que deseja cancelar a baixa?',
      },
      confirmar: () => {
        // Atualiza a lista de cancelamento com o novo UUID
        setCancelarBaixas((prevCancelarBaixas) => {
          const updatedCancelarBaixas = [...prevCancelarBaixas, id];
          formik.setFieldValue('cancelarBaixas', updatedCancelarBaixas);
          return updatedCancelarBaixas;
        });

        // Atualiza a lista de baixas removendo o elemento com o id
        setBaixasState((prev) => prev.filter((item) => item.id !== id));
      },
    });
  };

  return (
    <>
      <Grid container>
        {showTitle && (
          <Grid item xs={12}>
            <FormTitle title="Recebimentos realizados" />
          </Grid>
        )}
        {baixasState?.map((baixa, index) => (
          <Grid container style={{ marginBottom: 10 }} xs={12}>
            <Grid item key={index} xs={showCancelarBaixa ? 2 : 4}>
              <TextLabel
                id="dataRecebimento"
                label="Data do recebimento"
                value={baixa?.dataRecebimento ? DataBR(baixa?.dataRecebimento) : '-'}
              />
            </Grid>
            <Grid item key={index} xs={showCancelarBaixa ? 2 : 4}>
              <TextLabel
                id="dataLiquidacao"
                label="Data da liquidação"
                value={baixa?.dataLiquidacao ? DataBR(baixa?.dataLiquidacao) : '-'}
              />
            </Grid>
            <Grid item xs={showCancelarBaixa ? 2 : 4}>
              <TextLabel
                id="valorRecebimento"
                label="Valor recebido (R$)"
                value={baixa?.valorPago ? getCurrency(baixa?.valorPago).replace('R$', '') : '-'}
              />
            </Grid>
            <Grid item xs={showCancelarBaixa ? 2 : 4}>
              <TextLabel
                id="formaRecebimento"
                label="Forma de recebimento"
                value={FORMA_RECEBIMENTO[baixa?.formaRecebimento] || '-'}
              />
            </Grid>
            {showCancelarBaixa && (
              <Grid
                item
                style={{ justifyContent: 'center', alignContent: 'center', marginLeft: 15 }}
                xs={showCancelarBaixa ? 2 : 4}
              >
                <Tooltip title="Cancelar baixa" placement="right-end">
                  <IconButton onClick={handleCancelarBaixa(baixa?.id)}>
                    <MdHighlightOff size={18} />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default ContaReceberRecebimentosRealizados;
